(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const mediaQuery = window.matchMedia('(max-width: 767px)');
  const items = document.querySelectorAll('.dr-footer__accordion-item');

  if (!items.length) return;

  function setupAccordion() {
    items.forEach((item) => {
      const trigger = item.querySelector('.dr-footer__accordion-trigger');
      if (!trigger) return;

      if (mediaQuery.matches) {
        const isOpen = item.classList.contains('is-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      } else {
        item.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  }

  items.forEach((item) => {
    const trigger = item.querySelector('.dr-footer__accordion-trigger');
    if (!trigger) return;

    trigger.addEventListener('click', function () {
      if (!mediaQuery.matches) return;

      const isOpen = item.classList.contains('is-open');

      item.classList.toggle('is-open', !isOpen);
      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });
  });

  setupAccordion();

  if (typeof mediaQuery.addEventListener === 'function') {
    mediaQuery.addEventListener('change', setupAccordion);
  } else {
    mediaQuery.addListener(setupAccordion);
  }
});

  } catch(e) { console.error(e); }
})();
})();
